import clsx from 'clsx';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@/components/ui/IconButton';
import styles from './RightDrawer.module.css';

export interface RightDrawerProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  overlay?: boolean;
}

export function RightDrawer({ open, onClose, children, title, overlay = false }: RightDrawerProps) {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <>
      {overlay && (
        <button
          type="button"
          className={styles.scrim}
          onClick={onClose}
          aria-label={t('common.close')}
        />
      )}
      <aside
        className={clsx('chrome-surface', styles.drawer, overlay && styles.overlay)}
        aria-label={title}
      >
        {overlay && (
          <div className={styles.handleWrap} aria-hidden="true">
            <span className={styles.handle} />
          </div>
        )}
        {(title || overlay) && (
          <header className={styles.header}>
            {title && <h2 className={styles.title}>{title}</h2>}
            {overlay && (
              <IconButton label={t('common.close')} onClick={onClose}>
                <X size={16} />
              </IconButton>
            )}
          </header>
        )}
        <div className={styles.body}>{children}</div>
      </aside>
    </>
  );
}
